import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ReplyAll from './icon-reply-all.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ReplyAll {...validProps} />;
}
SvgComponent.iconName = 'reply-all';

/**
 * @deprecated This is a legacy icon
 */
export const ReplyAllIcon = svgIconWrapper(SvgComponent);
